import { Box, Button, Heading } from "@chakra-ui/react";
import { useQuery } from "@tanstack/react-query";
import dayjs from "dayjs";
import { listingsModel } from "models/listings";
import { useParams } from "react-router-dom";
import { ScreenWrapper } from "components/screen-wrapper";
import { Table } from "components/table/table";
import { dateFormats } from "utils/date";

const COLUMNS = [
  {
    label: "File name",
    id: "name",
  },
  {
    label: "Type",
    id: "type",
    formatValue: (value: { id: string; label: string }) => value.label,
  },
  {
    label: "Date uploaded",
    id: "uploaded_at",
    formatValue: (value: string) =>
      dayjs(value).format(dateFormats.dayMonthYear),
  },
];

export function DocumentsScreen() {
  const { propertyId } = useParams();
  const { data, isLoading, isFetching } = useQuery(
    listingsModel.queries.read(propertyId),
  );

  if (!data) return null;

  return (
    <ScreenWrapper>
      <Heading size={{ base: "2xl", md: "lg" }} fontWeight={700} as={"h1"}>
        Documents
      </Heading>

      <Box
        p={0}
        border={"1px solid"}
        borderColor={"gray.200"}
        borderRadius={"8px"}
        overflow={"hidden"}
      >
        <Table
          isLoading={isLoading}
          isFetching={isFetching}
          columns={COLUMNS}
          rows={data?.documents ?? []}
          customRowCell={(row) => (
            <a href={row.url}>
              <Button colorScheme={"gray"} variant={"outline"}>
                Download
              </Button>
            </a>
          )}
          emptyProps={{
            emptyMessage: "No documents found.",
            emptyDesc: "Please check back later.",
          }}
        />
      </Box>
    </ScreenWrapper>
  );
}
